
import Static from '~/components/Static';
import Resource from '~/components/resource/Resource';
import Error404 from '~/components/Error404';
import Error500 from '~/components/Error500.vue';

export default {
    name: 'contentPage',
    components: {
        Error500,
        Resource,
        Static,
        Error404,
    },
    layout(context) {
        return context.layout;
    },
    asyncData(context) {
        return context.data;
    },
};
